module.exports = __webpack_public_path__ + "static/media/Circulo-Alimenticio.59390bdd.gif";